import { Component, ElementRef, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';

import * as animations from '@shared/core/animations';
import * as Services from '@shared/core/services';

import { ViewsContainerComponent as SharedViewsContainer } from '@shared/core/views/viewsContainer';

@Component({
    templateUrl: './views.component.html',
    animations: [
        trigger('routeAnimations', [
            transition('* <=> *', [
                useAnimation(animations.fadeInOut)
            ])
        ]),
    ],
})
export class ViewsComponent extends SharedViewsContainer implements OnDestroy {
    @ViewChild('modals', { read: ViewContainerRef, static: false }) modals: ViewContainerRef;
    @ViewChild('cart', { read: ViewContainerRef, static: false }) cart: ViewContainerRef;

    constructor(
        public initService: Services.InitService,
        public elementRef: ElementRef,
        public lazyLoaderService: Services.LazyLoaderService,
    ) {
        super(initService);
    }

    ngAfterViewInit() {
        this.lazyLoaderService.loadModuleWithComponent({
            viewRefContainer: this.modals
        });
        this.lazyLoaderService.loadModuleWithComponent({
            viewRefContainer: this.cart
        });
    }

    ngOnDestroy() {
        //
        //  IE & Safari bug - inner router doesn't get destroyed properly when
        //  using animations. This is temp fix.
        //
        if (this.elementRef?.nativeElement) {
            try {
                (this.elementRef.nativeElement as HTMLDivElement).remove();
            } catch (ex) {
                console.error('Was unable to cleanup after router-outlet', ex);
            }

        }
    }
}
